import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function InfoTooltip({
  triggerClassName = '',
  tooltipId = 'tooltip',
  tooltipText,
  tooltipPlacement = 'bottom',
}) {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={(
        <Tooltip id={tooltipId}>
          {tooltipText}
        </Tooltip>
    )}
    >
      <i className={`fas fa-info-circle ${triggerClassName}`} />
    </OverlayTrigger>
  );
}

InfoTooltip.propTypes = {
  triggerClassName: PropTypes.string,
  tooltipId: PropTypes.string,
  tooltipText: PropTypes.string.isRequired,
  tooltipPlacement: PropTypes.string,
};

InfoTooltip.defaultProps = {
  triggerClassName: '',
  tooltipId: 'tooltip',
  tooltipPlacement: 'bottom',
};

export default InfoTooltip;
